module.exports = __webpack_public_path__ + "static/img/f7.d965768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/f7.png
// module id = W2ex
// module chunks = 2